<div class="einstallen-mobile-review">
    <kiene-mobile-page-header [ueberschrift]="'Liste abschließen'" (backClick)="onBack()"></kiene-mobile-page-header>

    <div class="einstallen-mobile-review__body">
        <div class="einstallen-mobile-review__gruppe" *ngIf="gruppe?.bezeichnung">
            <div class="einstallen-mobile-review__gruppe-label">Gruppe</div>
            <div>{{ gruppe.bezeichnung }}<span *ngIf="gruppe?.stall"> | {{ gruppe.stall }}</span></div>
        </div>

        <div *ngIf="isLoadingReview" class="einstallen-mobile-review__state">Lade Zusammenfassung…</div>

        <ng-container *ngIf="!isLoadingReview">
            <div class="einstallen-mobile-review__option">
                <mat-checkbox [disabled]="overview.anzahlPassUndOhrmarke <= 0" [(ngModel)]="hitOptionen.passUndOhrmarke">
                    Ohrmarke und Pass gescannt ({{ overview.anzahlPassUndOhrmarke }} Stk.)
                </mat-checkbox>
            </div>
            <div class="einstallen-mobile-review__option">
                <mat-checkbox [disabled]="overview.anzahlPass <= 0" [(ngModel)]="hitOptionen.nurPassGescannt">
                    nur Pass gescannt ({{ overview.anzahlPass }} Stk.)
                </mat-checkbox>
            </div>
            <div class="einstallen-mobile-review__option">
                <mat-checkbox [disabled]="overview.anzahlOhrmarke <= 0" [(ngModel)]="hitOptionen.nurOhrmarkeGescannt">
                    nur Ohrmarke gescannt ({{ overview.anzahlOhrmarke }} Stk.)
                </mat-checkbox>
            </div>
            <div class="einstallen-mobile-review__option">
                <mat-checkbox [disabled]="overview.anzahlCsv <= 0" [(ngModel)]="hitOptionen.wederPassNochOhrmarke">
                    nur CSV-Import ({{ overview.anzahlCsv }} Stk.)
                </mat-checkbox>
            </div>

            <div *ngIf="canEditGewicht" class="einstallen-mobile-review__summary">
                <div class="einstallen-mobile-review__summary-label">Tiere in dieser Liste</div>
                <div class="einstallen-mobile-review__summary-row">
                    <span>Anzahl</span>
                    <span>{{ last10SuccessfulScansCount }} Stk.</span>
                </div>
                <div class="einstallen-mobile-review__summary-row" *ngIf="showLast10ScansGewicht">
                    <span>Gesamtgewicht</span>
                    <span>{{ last10ScansGesamtGewicht | number: '1.1-1' : 'de' }} kg</span>
                </div>
                <div class="einstallen-mobile-review__summary-warning" *ngIf="missingGewichteCount > 0">
                    Für {{ missingGewichteCount }} von {{ last10SuccessfulScansCount }} Tieren fehlt das Einstallgewicht.
                </div>
                <div class="einstallen-mobile-review__summary-actions" *ngIf="missingGewichteCount > 0">
                    <button mat-stroked-button color="accent" type="button" (click)="gewichteBearbeiten()">
                        Gewichte bearbeiten
                    </button>
                </div>
            </div>

            <div *ngIf="overview.nichtMeldbar > 0" class="einstallen-mobile-review__warning">
                Tiere ohne Einstalldatum: {{ overview.nichtMeldbar }}
            </div>
        </ng-container>
    </div>

    <div class="einstallen-mobile-review__footer">
        <button mat-stroked-button color="accent" type="button" [disabled]="isBusy" (click)="abschliessen()">
            Abschließen
        </button>
        <button
            mat-flat-button
            color="accent"
            type="button"
            data-cy="einstallen-mobile-abschliessen-melden"
            [disabled]="isBusy || !canSubmitMelden"
            (click)="submit()"
        >
            Abschließen melden
        </button>
    </div>
</div>
